<template>
    <div>
        <chat :chatIdentifier="$route.params.identifier"></chat>
    </div>
</template>

<script lang="ts">
import { Options, Vue } from 'vue-class-component';

@Options({})
export default class chatRoomDetail extends Vue {

}

</script>

